(ns app.front.view.group.admin.import.attachment
  (:require [app.domain.attachment.model :as attachment-model]
            [app.front.view.group.admin.import.common :as import-session-common]
            [core.front.event :refer [<sub]]
            [core.front.href :as href]))

(defmethod import-session-common/entities-cols :import-session.type/attachment [_]
  (let [tr (<sub [:tr])]
    [[:entity/type
      (comp tr vector :entity/type)]
     [:workspace/municipal-case-id
      ;; parent of the attachment is ws until import is finalized
      (comp :workspace/municipal-case-id :entity/parent)
      {}]
     [:file/filename
      #(->> % :attachment/versions first :attachment.version/files (remove nil?) first :attachment.version.file/filename)
      {}]
     [:data-import/attachment-type
      #(-> % :attachment/types first (attachment-model/attachment-type-label :en))
      {}]]))

(defmethod import-session-common/entity-href :import-session.type/attachment [_ attachment]
  (href/href :view/workspace {:workspace-id (-> attachment
                                                :entity/parent
                                                :workspace/id)}))

(defmethod import-session-common/entities-cols :import-session.type/property-attachment [_]
  (let [tr (<sub [:tr])]
    [[:entity/type
      (comp tr vector :entity/type)]
     [:property/id
      (comp :property/verified-id :entity/parent)
      {}]
     [:file/filename
      #(->> % :attachment/versions first :attachment.version/files (remove nil?) first :attachment.version.file/filename)
      {}]
     [:data-import/attachment-type
      #(-> % :attachment/types first (attachment-model/attachment-type-label :en))
      {}]]))

(defmethod import-session-common/entity-href :import-session.type/property-attachment [_ attachment]
  (href/href :view/property {:db-id (-> attachment
                                        :entity/parent
                                        :db/id)}))
